import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";

/* Presentation-only password field with visibility toggle. Value/onChange/
   validation attributes pass straight through to the existing Input. */
export function PasswordInput({ className = "", testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative mt-1">
      <Lock className="absolute left-3 top-1/2 -translate-y-1/2 dyn-auth-icon" size={16} />
      <Input
        {...props}
        type={show ? "text" : "password"}
        className={`dyn-auth-input pl-9 pr-10 ${className}`}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="dyn-eye-btn absolute right-3 top-1/2 -translate-y-1/2"
        aria-label={show ? "Sembunyikan password" : "Tampilkan password"}
        aria-pressed={show}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
